import { render, staticRenderFns } from "./EditDataSourceAzureDataFactory.vue?vue&type=template&id=5a764e9b&scoped=true&"
import script from "./EditDataSourceAzureDataFactory.vue?vue&type=script&lang=js&"
export * from "./EditDataSourceAzureDataFactory.vue?vue&type=script&lang=js&"
import style0 from "./EditDataSourceAzureDataFactory.vue?vue&type=style&index=0&id=5a764e9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a764e9b",
  null
  
)

export default component.exports